<!-- pass data as yyyy-mm-dd -->

<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menu"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-on="on"
        :disabled="disabled"
        v-model="formattedDate"
        :label="label"
        :prepend-icon="noIcon ? '' : 'event'"
        :rules="rules"
        readonly
        :solo="solo"
        :hide-details="hideDetails"
      />
    </template>

    <v-date-picker
      :locale="language"
      :disabled="disabled"
      v-model="date"
      :min="min"
      :max="max"
      @input="onInputChange"
    />
  </v-menu>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "VuetifyDatepicker",
  props: [
    'value',
    'label',
    'min',
    'max',
    'rules',
    'noIcon',
    'clearable',
    'autoClose',
    'disabled',
    'solo',
    'hideDetails',
  ],
  beforeMount() {
    this.date = this.value;
  },
  data() {
    return {
      menu: false,
      date: null
    };
  },
  methods: {
    onInputChange(date) {
      this.$emit("input", date);
      this.$emit("change", date);
      if (this.autoClose) {
        this.menu = false;
      }
    }
  },
  computed: {
    ...mapGetters(["userData"]),

    formattedDate: function() {
      return this.value;
    },

    language() {
      return this.userData.lang || "en";
    }
  },
  watch: {
    value(newVal) {
      if (newVal !== this.date) {
        this.date = newVal;
      }
    },
    date(newVal) {
      this.$emit("input", this.date);
    }
  }
};
</script>
